import { ArrowRight, Shield, Zap, Home, Store } from "lucide-react";
import { useNavigate } from "react-router-dom";

const quickLinks = [
  { icon: Home, label: "Residenziale", href: "/residenziale" },
  { icon: Store, label: "PMI", href: "/pmi" },
];

export const HeroSection = ({ onConfigureClick }) => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center hero-overlay overflow-hidden"
      style={{
        backgroundImage: "url('https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 sm:py-40">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6 animate-fade-in-up">
            <span className="inline-flex items-center gap-1.5 bg-emerald-500/20 text-emerald-300 text-xs font-semibold px-3 py-1.5 rounded-full border border-emerald-500/30">
              <Zap className="w-3 h-3" />
              Il Tuo Hub per l'Energia Verde
            </span>
          </div>

          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight animate-fade-in-up delay-100"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="hero-title"
          >
            Soluzioni di<br />
            <span className="text-emerald-400">Energia Solare</span><br />
            per Ogni Settore
          </h1>

          <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-lg leading-relaxed animate-fade-in-up delay-200" data-testid="hero-subtitle">
            Dalla casa alle PMI: progettiamo il futuro energetico su misura per te. Preventivi gratuiti da partner certificati.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-in-up delay-300">
            <button
              onClick={onConfigureClick}
              className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-full px-8 py-4 text-base btn-scale shadow-xl shadow-emerald-500/30 animate-pulse-green"
              data-testid="hero-cta-button"
            >
              Richiedi Preventivo Gratuito
              <ArrowRight className="w-5 h-5" />
            </button>
            <button
              onClick={() => navigate("/prodotti")}
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full px-8 py-4 text-base border border-white/20 transition-colors duration-200"
              data-testid="hero-secondary-button"
            >
              Scopri i Prodotti
            </button>
          </div>

          <div className="mt-12 hidden sm:flex items-center gap-3 animate-fade-in-up delay-400">
            {quickLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => navigate(link.href)}
                className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white/80 hover:text-white text-xs font-medium rounded-full px-4 py-2 border border-white/10 transition-all duration-200 cursor-pointer"
                data-testid={`hero-quick-${link.label.toLowerCase()}`}
              >
                <link.icon className="w-3.5 h-3.5" />
                {link.label}
              </button>
            ))}
          </div>

          <div className="mt-6 flex items-center gap-6 animate-fade-in-up delay-500">
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-emerald-400" />
              <span className="text-sm text-slate-400">100% Gratuito</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-emerald-400" />
              <span className="text-sm text-slate-400">Senza Impegno</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-emerald-400" />
              <span className="text-sm text-slate-400">Partner Certificati</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
